<section *ngIf="myself" class="user-settings-consents-wrapper" [attr.aria-labelledby]="'consents-heading'">
  <app-cr-header id="consents-heading" [headingLevel]="2">
    {{ 'USER_SETTINGS.USER_SETTINGS_CONSENTS' | translate }}
  </app-cr-header>

  <nz-table
    *ngIf="tableConsents as data"
    class="user-settings-consents-table"
    [nzData]="tableConsents"
    [nzHideOnSinglePage]="true">
    <caption class="sr-only">
      {{
        'USER_SETTINGS.USER_SETTINGS_CONSENTS_TABLE_CAPTION' | translate
      }}
    </caption>

    <thead>
      <tr>
        <th scope="col" class="name-cell header">{{ 'USER_SETTINGS.CONSENTS.LABELS.NAME' | translate }}</th>
        <th scope="col" class="source-cell header">{{ 'USER_SETTINGS.CONSENTS.LABELS.SOURCE' | translate }}</th>
        <th scope="col" class="status-cell header">{{ 'USER_SETTINGS.CONSENTS.LABELS.STATUS' | translate }}</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let item of data">
        <td class="name-cell value">{{ item.label }}</td>

        <td class="source-cell value">
          <span *ngIf="item.urlHtml" [innerHTML]="item.urlHtml"></span>
          <span *ngIf="!item.urlHtml">-</span>
        </td>

        <td
          class="status-cell value"
          [attr.aria-label]="
            item.acceptedAt
              ? ('USER_SETTINGS.USER_SETTINGS_CONSENTS_GRANTED' | translate)
              : ('USER_SETTINGS.USER_SETTINGS_CONSENTS_NOT_GRANTED' | translate)
          ">
          <ng-container *ngIf="item.acceptedAt">
            <mat-icon *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'" class="granted" [attr.aria-hidden]="true">
              check
            </mat-icon>
            <span>
              {{ 'USER_SETTINGS.CONSENTS.CONSENT_GRANTED' | translate }}:
              <b>{{ item.acceptedAt | date: 'dd.MM.yyyy HH:mm' }}</b>
            </span>
          </ng-container>

          <ng-container *ngIf="!item.acceptedAt">
            <mat-icon *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'" class="not-granted" [attr.aria-hidden]="true">
              close
            </mat-icon>
            <span>{{ 'USER_SETTINGS.CONSENTS.CONSENT_NOT_GRANTED' | translate }}</span>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <div *ngIf="!tableConsents" class="loading-wrapper" role="status" aria-live="polite">
    <mat-spinner [diameter]="50" [attr.aria-hidden]="true"></mat-spinner>

    <div class="spinner-message">
      {{ 'USER_SETTINGS.LOADING_CONSENTS' | translate }}
    </div>
  </div>
</section>
